import React, { useEffect, useState } from "react";
import { connect } from "formik";
import { CTA } from "@coverme/forms";

export const WizardButtons = ({
    formik: { submitForm, errors, dirty, values, validateForm },
    isFirstPage,
    navigateToNextPage,
    navigateToPreviousPage,
    doNotSubmitIfDirty = true,
    showValidationErrorsOnLoad = false,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (validateForm) {
            const promiseResult = validateForm();
            if (showValidationErrorsOnLoad) {
                promiseResult.then(valErrors => {
                    const hasErrors = Object.keys(valErrors || {}).length > 0;
                    if (hasErrors) {
                        // Invoking submitForm causes all validation errors to be shown
                        submitForm();
                    }
                });
            }
        }
    }, []);
    const hasErrors = Object.keys(errors || {}).length > 0;

    function navigateWithLoadingBar() {
        setIsLoading(true);
        const response = navigateToNextPage(values);
        if (response?.then) {
            response.then(() => {
                setIsLoading(false);
            });
            response.catch(() => {
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const onSubmit = () => {
        if (doNotSubmitIfDirty && !hasErrors) {
            if (dirty === false) {
                return navigateToNextPage(values);
            }
        }

        if (submitForm) {
            if (hasErrors) {
                submitForm();
                return;
            }
            const response = submitForm();
            if (response?.then) {
                response.then(() => {
                    navigateWithLoadingBar(values);
                });
            } else {
                navigateWithLoadingBar(values);
            }
        } else {
            navigateWithLoadingBar(values);
        }
    };

    return (
        <div className="wizard-buttons">
            {!isFirstPage && (
                <CTA size={"large"} ctaType={"button"} styleType={"grey-dark-alt"} click={navigateToPreviousPage}>
                    &laquo; Back
                </CTA>
            )}
            <CTA
                size={"large"}
                ctaType={"button"}
                styleType={"blue"}
                click={onSubmit}
                loading={isLoading}
                disabled={isLoading}
            >
                Next &raquo;
            </CTA>
        </div>
    );
};

export const WizardButtonsField = connect(WizardButtons);
